import { jsx as _jsx } from "react/jsx-runtime";
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import { Text } from '@famly/mf_data-display_text';
import { useDataProps, useAriaProps } from '@famly/mf_ts-utils_data-aria-props';
import { extractSystemStyles } from '@famly/mf_system_system-props';
import { useResponsiveSize } from '@famly/mf_util_breakpoints';
const maxUpperBound = 999;
const pillHeightRegular = 24;
const pillHeightCompact = 16;
/**
 * Width budget per character. Wide enough for the widest glyph the pill can show, a zero at 8.34px
 * on the regular type size, so the count never reaches past the side padding.
 */
const widthPerCharacter = 8;
export const NumericPill = (props) => {
    const { count, color = 'n400', backgroundColor = 'n75', max = 999, showPlus = false } = props;
    const size = useResponsiveSize(props.size);
    const dataProps = useDataProps(props);
    const ariaProps = useAriaProps(props);
    const { sx: alignmentSx } = extractSystemStyles(props);
    const theme = useTheme();
    const clampedMax = max < 1 ? maxUpperBound : Math.min(max, maxUpperBound);
    const baseDisplayCount = count > clampedMax ? `${clampedMax}+` : count;
    const displayCount = showPlus && count > 0 ? `+${baseDisplayCount}` : baseDisplayCount;
    const height = size === 'compact' ? pillHeightCompact : pillHeightRegular;
    const sidePadding = size === 'compact' ? 4 : 8;
    /**
     * Stepping the width per character keeps every pill on a whole pixel, which letting the text
     * size the box does not: the glyph advances are fractional. The floor at the height keeps a
     * single character round, and each further character widens the box into a stadium.
     */
    const width = Math.max(height, `${displayCount}`.length * widthPerCharacter + sidePadding * 2);
    return (_jsx(Stack, { display: "inline-flex", direction: "row", alignItems: "center", justifyContent: "center", height: `${height}px`, width: `${width}px`, boxSizing: "border-box", paddingBlock: 1, borderRadius: 6, bgcolor: theme.modernFamlyTheme.colorPalette[backgroundColor], sx: theme => ({
            ...alignmentSx(theme),
        }), ...dataProps, ...ariaProps, children: _jsx(Text, { variant: size === 'compact' ? 'micro' : 'subtitle', color: color, trimToCapHeight: true, "data-e2e-class": "numeric-pill-text", children: displayCount }) }));
};
